import React from 'react';
import PropTypes from 'prop-types';
import withStatsEvents from 'shared/hocs/stats/withStatsEvents';
import { setDataLayer } from 'shared/actions/globals';
import { connect } from 'react-redux';
import { EVENTS } from 'shared/constants/gtmEvents';
import { getDisplayName } from '../helpers/common';
import API from '../constants/api';

import { withFetch } from './withFetch';

const withAdvertPhoneView = WrappedComponent => {
  const Component = connect(null, { setDataLayer })(
    class extends React.Component {
      static displayName = `withAdvertPhoneView(${getDisplayName(WrappedComponent)})`;

      static propTypes = {
        events: PropTypes.shape({
          dispatchPhoneViewEvent: PropTypes.func,
        }).isRequired,
        advertID: PropTypes.number,
        authorID: PropTypes.number,
        isSpare: PropTypes.bool,
        transport: PropTypes.shape(),
        agency: PropTypes.shape(),
        setDataLayer: PropTypes.func.isRequired,
        fetch: PropTypes.func.isRequired,
      };
      static defaultProps = {
        advertID: null,
        authorID: null,
        isSpare: false,
        transport: null,
        agency: null,
      };

      state = {
        phones: null,
        hasDispatchedEvent: false,
        isFetching: false,
      };

      fetchPhones = (fetch, advertId) => {
        this.setState({ isFetching: true });

        return fetch((this.props.isSpare ? API.SPARE_PARTS.PHONES : API.ADVERT.PHONES)(advertId))
          .then(r => r.json())
          .then(phones => {
            this.setState({ isFetching: false });

            return phones || [];
          })
          .catch(() => {
            this.setState({ isFetching: false });

            return [];
          });
      };

      handleShowPhoneClick = (advertID, shouldSendEvent = true, cb) => {
        if (shouldSendEvent) {
          this.props.setDataLayer(EVENTS.showPhoneClick);
        }

        const { fetch, events, authorID, transport, agency, isSpare } = this.props;
        const agencyId = agency && agency.id;
        const transportId = transport && transport.id;

        if (!this.state.hasDispatchedEvent) {
          events.dispatchPhoneViewEvent(advertID, authorID, transportId, agencyId, isSpare);
          this.setState({ hasDispatchedEvent: true });
        }

        if (this.state.phones) {
          if (typeof cb === 'function') cb(this.state.phones);
          return;
        }
        if (this.state.isFetching) {
          return;
        }

        this.fetchPhones(fetch, advertID).then(phones => {
          this.setState({ phones });
          if (typeof cb === 'function') cb(phones);
        });
      };

      render() {
        const { events, ...props } = this.props;
        const { isFetching } = this.state;

        return (
          <WrappedComponent
            phones={this.state.phones}
            requestShowPhones={this.handleShowPhoneClick}
            isFetching={isFetching}
            {...props}
          />
        );
      }
    },
  );

  return withStatsEvents(withFetch(Component));
};

export default withAdvertPhoneView;



// WEBPACK FOOTER //
// ./src/shared/hocs/withAdvertPhoneView.js